import { Component, OnInit, Output, EventEmitter, Input, LOCALE_ID, Inject } from '@angular/core';
import { MetadataService } from '../../metadata.service';
import { GSPMetadataService } from '../../../metadata.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-treeclassifier',
  templateUrl: './treeclassifier.component.html',
  styleUrls: ['./treeclassifier.component.css']
})

export class TreeclassifierComponent implements OnInit {
  @Input() metadataPath: string;
  @Input() onlyDisplayCurrentProject: boolean;
  files: any;
  selectedKeys = ['0'];
  classifier: any[] = [
    { id: 'project', text: '当前工程' }
  ];
  public LOCALES = {
    en: {
      metadata_offline: 'Offline Metadata',
      metadata_repository: 'Repository Metadata',
      metadata_reference: 'Referenced Metadata',
      metadata_bo: 'BO Internal Metadata',
      metadata_database: 'Database Metadata'
    },
    "zh-CHS": {
      metadata_offline: '离线的元数据',
      metadata_repository: '仓库中元数据',
      metadata_reference: '引用的元数据',
      metadata_bo: 'BO内元数据',
      metadata_database: '数据库中元数据'
    },
    "zh-CHT": {
      metadata_offline: '離線的元數據',
      metadata_repository: '倉庫中的元數據',
      metadata_reference: '引用的元數據',
      metadata_bo: 'BO 內元數據',
      metadata_database: '資料庫中的元數據'
    }
  };

  localeData = null;
  classifiers: any[];
  constructor(private metadataService: MetadataService, private gspMetadataService: GSPMetadataService, @Inject(LOCALE_ID) private localeID: string) {
    this.localeID = localStorage.getItem('languageCode')  || 'zh-CHS';
    this.localeData = this.LOCALES[this.localeID];
    this.classifiers = [
      { id: 'bo', text: this.localeData.metadata_bo },  // 0
      { id: 'local', text: this.localeData.metadata_offline },    // 1
      { id: 'remote', text: this.localeData.metadata_repository },   // 2
      { id: 'ref', text: this.localeData.metadata_reference },       // 3
      { id: 'db', text: this.localeData.metadata_database }       // 4
    ];
  }

  ngOnInit() {
    this.metadataService.GetMetadataProjPath(this.metadataPath).subscribe(proj => {
      this.metadataService.currentProjectPath = proj.projectPath;
      if (this.onlyDisplayCurrentProject === true) {
        this.files = this.classifier;
        this.metadataService.selectedChange.emit(this.files[0]); // 默认本工程下的
      } else {
        // 树节点mock数据
        this.gspMetadataService.getMavenSetting().subscribe(maven => {
          if (maven === true) {
            this.gspMetadataService.getCodeLanguage(proj.projectPath).subscribe(lang => {
              if (lang === 'java') {
                this.files = this.classifiers;
                this.metadataService.selectedChange.emit(this.files[0]); // 默认本工程下的
              } else {
                this.files = this.metadataService.getMetadataClassifier('project');
                this.metadataService.selectedChange.emit(this.files[0]); // 默认本工程下的
              }
            });
          } else {
            this.files = this.metadataService.getMetadataClassifier('project');
            this.metadataService.selectedChange.emit(this.files[0]); // 默认本工程下的
          }
        });
      }
    });
  }

  // 树节点点击后事件
  nodeSelect(event) {
    this.metadataService.selectedChange.emit(event.dataItem);
  }
}
